import React, { useContext, FunctionComponent } from 'react';

import { ActionTypes, AssetDetailsDispatch, ValidationErrors } from '@components/asset/modal/tabs/edit/EditTabTypes';
import { StandardTextField } from '@components/library/text-field';
import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';

interface AssetNameScopedContext {
  state: {
    editState: {
      assetName: string;
    };
    errorState: ValidationErrors[];
  };
  dispatch: AssetDetailsDispatch;
}

const AssetNameInput: FunctionComponent<{ assetNameCopy?: string }> = ({ assetNameCopy }) => {
  const { state, dispatch }: AssetNameScopedContext = useContext(assetModalContext);
  const { assetName } = state.editState;
  const hasNameError = state.errorState.includes(ValidationErrors.MissingAssetName);
  return (
    <StandardTextField
      className="name-input"
      error={hasNameError ? bfTranslate('Asset name required') : ''}
      id="name"
      label={assetNameCopy || bfTranslate('Asset Name')}
      name="name"
      onChange={(e: InputChangeEvent): void => dispatch(
        { type: ActionTypes.UpdateAsset, payload: { assetName: e.target.value } }
      )}
      placeholder=""
      value={assetName}
    />
  );
};

export default AssetNameInput;
